<template>
  <div>
    <div v-if="model.loadingList">
      Cargando...
    </div>
    <div v-else>
      <div v-if="model.error.hasError">
        {{ model.error.errorString }}
      </div>
      <!-- Loaded without errors -->
      <div v-else>
        <div v-if="model.isListEmpty">
          <p>No hay ventas pendientes de aprobación.</p>
          <p>
            Aparecerán aquí cuando un afiliado registre una compra que no tenga
            una venta registrada.
          </p>
        </div>
        <!-- List has elements -->
        <div v-else>
          <pending-table
            :rowList="model.list"
            :approveByIdFunction="approveById"
            :rejectByIdFunction="rejectById"
          >
          </pending-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PendingTable from "./PendingTable.vue";

import { VentaFacade as Facade } from "../../../service/comerciante/venta/venta.facade";
import { Util } from "../../../util";

export default {
  components: {
    PendingTable
  },
  data() {
    return {
      model: {
        loadingList: true,
        list: [],
        error: {
          hasError: false,
          errorString: undefined
        },
        isListEmpty: false
      }
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    async approveById(id) {
      await Facade.approveById(id);
      this.removeFromList(id);
    },
    dtoToViewModel(dto) {
      const porcentajeDescuentoString =
        dto.porcentajeDescuento.toString() + "%";

      const descontado = (dto.precioBase * dto.porcentajeDescuento) / 100;
      const descontadoString = Util.formatMoney(descontado);

      const basePriceString = Util.formatMoney(dto.precioBase);
      const cobrado = dto.precioBase - descontado;
      const cobradoString = Util.formatMoney(cobrado);

      return {
        ...dto,
        basePriceString,
        porcentajeDescuentoString,
        descontadoString,
        cobradoString
      };
    },
    async loadList() {
      this.model.loadingList = true;

      try {
        const list = await Facade.getPendingList();

        if (list && list.length) {
          this.model.list = list.map(dto => this.dtoToViewModel(dto));
          this.model.isListEmpty = false;
        } else {
          this.model.isListEmpty = true;
        }
      } catch (error) {
        this.model.error.errorString = "Ocurrió un error inesperado";

        this.model.error.hasError = true;
      }

      this.model.loadingList = false;
    },
    async rejectById(id) {
      await Facade.rejectById(id);
      this.removeFromList(id);
    },
    removeFromList(id) {
      const index = this.model.list.findIndex(e => e.id == id);

      if (index > -1) {
        Util.eliminarEn(this.model.list, index);
      }

      if (this.model.list.length <= 0) {
        this.model.isListEmpty = true;
      }
    }
  }
};
</script>